import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading3 } from '@blueprint/ui';

const Container = styled.div(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['8px']};
    `
);

const DiscoverHeader = styled(Heading3)(
    ({ theme }) => css`
        margin-top: ${theme.spacing['32px']};
        margin-bottom: ${theme.spacing['8px']};
    `
);

export { Container, DiscoverHeader };
